export const translations = {
  en: {
    nav: {
      about: 'About',
      focus: 'Focus',
      whyUs: 'Why Us',
      contact: 'Contact',
    },
    hero: {
      eyebrow: 'Paola Skin Lab — Est. 2024',
      headlineMain: 'Luxury Skincare, Self-Care & Personal Growth — ',
      headlineAccent: 'Elevated.',
      subheadline:
        'Paola Skin Lab is a premium informational brand focused on skincare education, beauty guidance, confidence, and personal growth for modern women.',
      ctaPrimary: 'Contact Us',
      ctaSecondary: 'Learn More',
    },
    about: {
      eyebrow: 'About',
      tagline:
        'Elevating your understanding of beauty, self-care, and personal confidence.',
      paragraph1:
        'Paola Skin Lab is a premium informational destination dedicated to demystifying skincare and empowering individuals through education. We believe that true beauty radiates from a foundation of knowledge, self-care, and unwavering confidence.',
      paragraph2:
        'Our focus extends beyond surface-level aesthetics. We provide comprehensive guidance designed to help you navigate the complexities of modern skincare, cultivate meaningful self-care rituals, and foster personal growth. By blending elegant editorial content with trustworthy insights, we aim to be your definitive resource for elevated living.',
      paragraph3:
        'Whether you are seeking to refine your daily routine or looking for inspiration to boost your personal confidence, Paola Skin Lab offers a refined, trustworthy, and modern approach to beauty and wellness education.',
    },
    focus: {
      eyebrow: 'Our Focus',
      heading: 'Areas of Expertise',
      items: [
        {
          title: 'Skincare Education',
          desc: 'In-depth informational guides to understand ingredients, routines, and skin health fundamentals.',
        },
        {
          title: 'Beauty Guidance',
          desc: 'Refined editorial insights and trustworthy advice for navigating the modern beauty landscape.',
        },
        {
          title: 'Self-Care Resources',
          desc: 'Curated practices and rituals designed to elevate your daily well-being and mental clarity.',
        },
        {
          title: 'Personal Growth',
          desc: 'Empowering content focused on holistic development, mindset shifts, and achieving your potential.',
        },
        {
          title: 'Confidence & Lifestyle',
          desc: 'Strategies to build unshakeable self-assurance and cultivate an elegant, intentional lifestyle.',
        },
        {
          title: 'Digital Content',
          desc: 'Premium informational materials, articles, and resources accessible anywhere, anytime.',
        },
      ],
    },
    whyUs: {
      eyebrow: 'Distinction',
      heading: 'Why Choose Paola Skin Lab',
      reasons: [
        'Premium brand approach',
        'Informational and educational focus',
        'Elegant and trustworthy brand philosophy',
        'Professional communication',
        'Modern and refined brand identity',
      ],
    },
    trust: {
      heading: 'A Foundation of Trust',
      intro:
        'We are committed to operating with the highest level of integrity, ensuring our community receives reliable information and professional service.',
      pillars: [
        'Transparent Communication',
        'Professional Support',
        'Informational Content',
        'Clear Policies',
      ],
      closingNote:
        'For business inquiries and verification, our contact information is readily available.',
      privacyLink: 'Privacy',
      termsLink: 'Terms',
    },
    contact: {
      eyebrow: 'Inquiries',
      heading: 'Get in Touch',
      intro:
        'For general inquiries, business questions, educational information, or support, please contact us below.',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      form: {
        name: 'Name',
        email: 'Email',
        phoneOptional: 'Phone (Optional)',
        message: 'Message',
        submit: 'Submit Inquiry',
        submitting: 'Sending...',
        successTitle: 'Thank You',
        successBody:
          'Your message has been received. We will be in touch shortly.',
        sendAnother: 'Send another message',
      },
    },
    footer: {
      tagline:
        'A premium informational brand focused on skincare education, beauty guidance, confidence, and personal growth.',
      contactHeading: 'Contact',
      exploreHeading: 'Explore',
      legalHeading: 'Legal',
      links: {
        about: 'About',
        focus: 'Our Focus',
        whyUs: 'Why Choose Us',
        privacy: 'Privacy Policy',
        terms: 'Terms & Conditions',
        disclaimer: 'Disclaimer',
        refund: 'Refund Policy',
      },
      rights: 'Paola Skin Lab. All rights reserved.',
      informationalNote: 'Informational Purposes Only',
    },
    legal: {
      common: {
        lastUpdated: 'Last Updated',
      },
      privacy: {
        title: 'Privacy Policy',
        intro:
          'Paola Skin Lab ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website (paolaskinlab.com) or interact with our informational content.',
        sections: [
          {
            heading: '1. Information We Collect',
            paragraphs: [
              'We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us, such as your name, email address, and phone number. We also automatically collect certain information when you visit our website, such as your IP address and browser characteristics, through cookies and similar technologies.',
            ],
          },
          {
            heading: '2. How We Use Your Information',
            paragraphs: [
              'We use the information we collect to communicate with you, provide our informational services, improve our website, and comply with legal obligations. We do not sell your personal information to third parties.',
            ],
          },
          {
            heading: '3. Data Retention and Security',
            paragraphs: [
              'We will only keep your personal information for as long as it is necessary for the purposes set out in this Privacy Policy. We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process.',
            ],
          },
          {
            heading: '4. Your Privacy Rights',
            paragraphs: [
              'Depending on your location, you may have certain rights regarding your personal information, such as the right to access, correct, or delete your data. To exercise these rights, please contact us.',
            ],
          },
          {
            heading: '5. Contact Us',
            paragraphs: [
              'If you have questions or comments about this notice, you may email us at sales@paolaskinlab.com.',
            ],
          },
        ],
      },
      terms: {
        title: 'Terms & Conditions',
        intro:
          'These Terms and Conditions constitute a legally binding agreement made between you and Paola Skin Lab concerning your access to and use of the paolaskinlab.com website.',
        sections: [
          {
            heading: '1. Acceptance of Terms',
            paragraphs: [
              'By accessing the site, you agree that you have read, understood, and agree to be bound by all of these Terms and Conditions. If you do not agree, you must discontinue use immediately.',
            ],
          },
          {
            heading: '2. Informational Purposes Only',
            paragraphs: [
              'All content provided on this website is for informational and educational purposes only. Paola Skin Lab is a premium informational brand focused on skincare education, beauty guidance, and personal growth. We do not provide medical advice, diagnosis, or treatment.',
            ],
          },
          {
            heading: '3. Intellectual Property Rights',
            paragraphs: [
              'Unless otherwise indicated, the site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the site are owned or controlled by us.',
            ],
          },
          {
            heading: '4. User Representations',
            paragraphs: [
              'By using the site, you represent and warrant that all registration information you submit will be true, accurate, current, and complete, and you will maintain the accuracy of such information.',
            ],
          },
          {
            heading: '5. Limitations of Liability',
            paragraphs: [
              'In no event will we or our directors, employees, or agents be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages arising from your use of the site.',
            ],
          },
          {
            heading: '6. Contact Us',
            paragraphs: [
              'In order to resolve a complaint regarding the site or to receive further information regarding use of the site, please contact us at sales@paolaskinlab.com.',
            ],
          },
        ],
      },
      disclaimer: {
        title: 'Disclaimer',
        intro:
          'The information provided by Paola Skin Lab ("we," "us," or "our") on paolaskinlab.com (the "Site") is for general informational and educational purposes only. All information on the Site is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Site.',
        sections: [
          {
            heading: '1. No Medical Advice',
            paragraphs: [
              'The Site cannot and does not contain medical or health advice. The skincare and beauty guidance information is provided for general informational and educational purposes only and is not a substitute for professional advice.',
              'Accordingly, before taking any actions based upon such information, we encourage you to consult with the appropriate professionals. We do not provide any kind of medical advice, diagnosis, treatment, or cure. The use or reliance of any information contained on the Site is solely at your own risk.',
            ],
          },
          {
            heading: '2. No Guarantees',
            paragraphs: [
              'Paola Skin Lab makes no guarantees regarding any specific results from the use of our informational content, guidance, or self-care resources. Results may vary significantly from person to person based on individual factors, skin types, and adherence to professional medical advice.',
            ],
          },
          {
            heading: '3. External Links Disclaimer',
            paragraphs: [
              'The Site may contain links to other websites or content belonging to or originating from third parties. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us.',
            ],
          },
          {
            heading: '4. Contact Us',
            paragraphs: [
              'If you have any questions regarding this disclaimer, please contact us at sales@paolaskinlab.com.',
            ],
          },
        ],
      },
      refund: {
        title: 'Refund Policy',
        intro:
          'Thank you for choosing Paola Skin Lab. This Refund Policy outlines the terms that apply to any current or future products, digital resources, educational materials, consultations, or services offered by Paola Skin Lab.',
        sections: [
          {
            heading: '1. Online Purchases',
            paragraphs: [
              'At this time, our website does not process direct online purchases or payments. Paola Skin Lab is currently an informational and educational platform, and no transactions are completed through this website.',
            ],
          },
          {
            heading: '2. Future Products and Services',
            paragraphs: [
              'Future digital products, educational resources, online courses, consultations, or other services that may be offered by Paola Skin Lab may be subject to specific refund terms communicated at the time of purchase. Customers are encouraged to review those terms carefully before completing any transaction.',
            ],
          },
          {
            heading: '3. Non-Refundable Items',
            paragraphs: [
              'The following items may be considered non-refundable:',
            ],
            list: [
              'Digital products that have already been accessed.',
              'Materials that have been downloaded or delivered electronically.',
              'Educational content or resources that have been provided in full.',
              'Consultations or services that have already been completed.',
            ],
          },
          {
            heading: '4. How to Request a Refund',
            paragraphs: [
              'All refund requests must be submitted in writing to sales@paolaskinlab.com. Please include your full name, the email address used for the purchase, the date of purchase, and a detailed explanation of the reason for your request.',
              'Refund requests are reviewed individually on a case-by-case basis. Approval is at the sole discretion of Paola Skin Lab and depends on the specific circumstances of each request.',
            ],
          },
          {
            heading: '5. Contact Us',
            paragraphs: [
              'If you have any questions concerning this Refund Policy, please contact us at sales@paolaskinlab.com.',
            ],
          },
        ],
      },
    },
  },
  es: {
    nav: {
      about: 'Nosotros',
      focus: 'Enfoque',
      whyUs: 'Por Qué Elegirnos',
      contact: 'Contacto',
    },
    hero: {
      eyebrow: 'Paola Skin Lab — Est. 2024',
      headlineMain: 'Cuidado de la Piel, Autocuidado y Crecimiento Personal — ',
      headlineAccent: 'Elevados.',
      subheadline:
        'Paola Skin Lab es una marca informativa premium enfocada en la educación sobre el cuidado de la piel, orientación de belleza, confianza y crecimiento personal para la mujer moderna.',
      ctaPrimary: 'Contáctanos',
      ctaSecondary: 'Saber Más',
    },
    about: {
      eyebrow: 'Nosotros',
      tagline:
        'Elevando tu comprensión de la belleza, el autocuidado y la confianza personal.',
      paragraph1:
        'Paola Skin Lab es un destino informativo premium dedicado a desmitificar el cuidado de la piel y empoderar a las personas a través de la educación. Creemos que la verdadera belleza irradia desde una base de conocimiento, autocuidado y confianza inquebrantable.',
      paragraph2:
        'Nuestro enfoque va más allá de la estética superficial. Proporcionamos orientación integral diseñada para ayudarte a navegar las complejidades del cuidado moderno de la piel, cultivar rituales significativos de autocuidado y fomentar el crecimiento personal. Al combinar contenido editorial elegante con conocimientos confiables, aspiramos a ser tu recurso definitivo para una vida elevada.',
      paragraph3:
        'Ya sea que busques refinar tu rutina diaria o busques inspiración para aumentar tu confianza personal, Paola Skin Lab ofrece un enfoque refinado, confiable y moderno para la educación en belleza y bienestar.',
    },
    focus: {
      eyebrow: 'Nuestro Enfoque',
      heading: 'Áreas de Especialidad',
      items: [
        {
          title: 'Educación en Skincare',
          desc: 'Guías informativas detalladas para comprender ingredientes, rutinas y fundamentos de la salud de la piel.',
        },
        {
          title: 'Orientación de Belleza',
          desc: 'Perspectivas editoriales refinadas y consejos confiables para navegar el panorama moderno de la belleza.',
        },
        {
          title: 'Recursos de Autocuidado',
          desc: 'Prácticas y rituales curados diseñados para elevar tu bienestar diario y claridad mental.',
        },
        {
          title: 'Crecimiento Personal',
          desc: 'Contenido empoderador enfocado en el desarrollo holístico, cambios de mentalidad y alcanzar tu potencial.',
        },
        {
          title: 'Confianza y Estilo de Vida',
          desc: 'Estrategias para construir una seguridad inquebrantable y cultivar un estilo de vida elegante e intencional.',
        },
        {
          title: 'Contenido Digital',
          desc: 'Materiales informativos premium, artículos y recursos accesibles en cualquier lugar y en cualquier momento.',
        },
      ],
    },
    whyUs: {
      eyebrow: 'Distinción',
      heading: 'Por Qué Elegir Paola Skin Lab',
      reasons: [
        'Enfoque de marca premium',
        'Enfoque informativo y educativo',
        'Filosofía de marca elegante y confiable',
        'Comunicación profesional',
        'Identidad de marca moderna y refinada',
      ],
    },
    trust: {
      heading: 'Una Base de Confianza',
      intro:
        'Estamos comprometidos a operar con el más alto nivel de integridad, asegurando que nuestra comunidad reciba información confiable y servicio profesional.',
      pillars: [
        'Comunicación Transparente',
        'Soporte Profesional',
        'Contenido Informativo',
        'Políticas Claras',
      ],
      closingNote:
        'Para consultas comerciales y verificación, nuestra información de contacto está disponible.',
      privacyLink: 'Privacidad',
      termsLink: 'Términos',
    },
    contact: {
      eyebrow: 'Consultas',
      heading: 'Ponte en Contacto',
      intro:
        'Para consultas generales, preguntas comerciales, información educativa o soporte, por favor contáctanos a continuación.',
      emailLabel: 'Correo Electrónico',
      phoneLabel: 'Teléfono',
      form: {
        name: 'Nombre',
        email: 'Correo Electrónico',
        phoneOptional: 'Teléfono (Opcional)',
        message: 'Mensaje',
        submit: 'Enviar Consulta',
        submitting: 'Enviando...',
        successTitle: 'Gracias',
        successBody:
          'Tu mensaje ha sido recibido. Nos pondremos en contacto en breve.',
        sendAnother: 'Enviar otro mensaje',
      },
    },
    footer: {
      tagline:
        'Una marca informativa premium enfocada en la educación sobre el cuidado de la piel, orientación de belleza, confianza y crecimiento personal.',
      contactHeading: 'Contacto',
      exploreHeading: 'Explorar',
      legalHeading: 'Legal',
      links: {
        about: 'Nosotros',
        focus: 'Nuestro Enfoque',
        whyUs: 'Por Qué Elegirnos',
        privacy: 'Política de Privacidad',
        terms: 'Términos y Condiciones',
        disclaimer: 'Descargo de Responsabilidad',
        refund: 'Política de Reembolso',
      },
      rights: 'Paola Skin Lab. Todos los derechos reservados.',
      informationalNote: 'Solo con Fines Informativos',
    },
    legal: {
      common: {
        lastUpdated: 'Última Actualización',
      },
      privacy: {
        title: 'Política de Privacidad',
        intro:
          'Paola Skin Lab ("nosotros", "nuestro" o "nos") respeta su privacidad y está comprometido a proteger sus datos personales. Esta Política de Privacidad explica cómo recopilamos, usamos, divulgamos y salvaguardamos su información cuando visita nuestro sitio web (paolaskinlab.com) o interactúa con nuestro contenido informativo.',
        sections: [
          {
            heading: '1. Información que Recopilamos',
            paragraphs: [
              'Recopilamos información personal que usted nos proporciona voluntariamente cuando expresa interés en obtener información sobre nosotros, como su nombre, dirección de correo electrónico y número de teléfono. También recopilamos automáticamente cierta información cuando visita nuestro sitio web, como su dirección IP y características del navegador, a través de cookies y tecnologías similares.',
            ],
          },
          {
            heading: '2. Cómo Usamos su Información',
            paragraphs: [
              'Usamos la información que recopilamos para comunicarnos con usted, proporcionar nuestros servicios informativos, mejorar nuestro sitio web y cumplir con obligaciones legales. No vendemos su información personal a terceros.',
            ],
          },
          {
            heading: '3. Retención y Seguridad de Datos',
            paragraphs: [
              'Solo conservaremos su información personal durante el tiempo que sea necesario para los fines establecidos en esta Política de Privacidad. Hemos implementado medidas de seguridad técnicas y organizativas apropiadas diseñadas para proteger la seguridad de cualquier información personal que procesemos.',
            ],
          },
          {
            heading: '4. Sus Derechos de Privacidad',
            paragraphs: [
              'Dependiendo de su ubicación, puede tener ciertos derechos con respecto a su información personal, como el derecho a acceder, corregir o eliminar sus datos. Para ejercer estos derechos, por favor contáctenos.',
            ],
          },
          {
            heading: '5. Contáctenos',
            paragraphs: [
              'Si tiene preguntas o comentarios sobre este aviso, puede enviarnos un correo electrónico a sales@paolaskinlab.com.',
            ],
          },
        ],
      },
      terms: {
        title: 'Términos y Condiciones',
        intro:
          'Estos Términos y Condiciones constituyen un acuerdo legalmente vinculante realizado entre usted y Paola Skin Lab con respecto a su acceso y uso del sitio web paolaskinlab.com.',
        sections: [
          {
            heading: '1. Aceptación de los Términos',
            paragraphs: [
              'Al acceder al sitio, usted acepta que ha leído, entendido y acepta estar sujeto a todos estos Términos y Condiciones. Si no está de acuerdo, debe suspender su uso inmediatamente.',
            ],
          },
          {
            heading: '2. Solo con Fines Informativos',
            paragraphs: [
              'Todo el contenido proporcionado en este sitio web es solo para fines informativos y educativos. Paola Skin Lab es una marca informativa premium enfocada en la educación sobre el cuidado de la piel, orientación de belleza y crecimiento personal. No proporcionamos asesoramiento médico, diagnóstico o tratamiento.',
            ],
          },
          {
            heading: '3. Derechos de Propiedad Intelectual',
            paragraphs: [
              'A menos que se indique lo contrario, el sitio es nuestra propiedad exclusiva y todo el código fuente, bases de datos, funcionalidad, software, diseños de sitios web, audio, video, texto, fotografías y gráficos en el sitio son de nuestra propiedad o están controlados por nosotros.',
            ],
          },
          {
            heading: '4. Representaciones del Usuario',
            paragraphs: [
              'Al usar el sitio, usted declara y garantiza que toda la información de registro que envíe será verdadera, precisa, actual y completa, y mantendrá la precisión de dicha información.',
            ],
          },
          {
            heading: '5. Limitaciones de Responsabilidad',
            paragraphs: [
              'En ningún caso nosotros o nuestros directores, empleados o agentes seremos responsables ante usted o cualquier tercero por daños directos, indirectos, consecuentes, ejemplares, incidentales, especiales o punitivos que surjan de su uso del sitio.',
            ],
          },
          {
            heading: '6. Contáctenos',
            paragraphs: [
              'Para resolver una queja con respecto al sitio o para recibir más información sobre el uso del sitio, por favor contáctenos en sales@paolaskinlab.com.',
            ],
          },
        ],
      },
      disclaimer: {
        title: 'Descargo de Responsabilidad',
        intro:
          'La información proporcionada por Paola Skin Lab ("nosotros", "nos" o "nuestro") en paolaskinlab.com (el "Sitio") es solo para fines informativos y educativos generales. Toda la información en el Sitio se proporciona de buena fe, sin embargo, no hacemos ninguna representación o garantía de ningún tipo, expresa o implícita, con respecto a la precisión, adecuación, validez, confiabilidad, disponibilidad o integridad de cualquier información en el Sitio.',
        sections: [
          {
            heading: '1. Sin Asesoramiento Médico',
            paragraphs: [
              'El Sitio no puede y no contiene asesoramiento médico o de salud. La información de orientación sobre el cuidado de la piel y belleza se proporciona solo para fines informativos y educativos generales y no es un sustituto del asesoramiento profesional.',
              'En consecuencia, antes de tomar cualquier medida basada en dicha información, le recomendamos que consulte con los profesionales adecuados. No proporcionamos ningún tipo de asesoramiento médico, diagnóstico, tratamiento o cura. El uso o la dependencia de cualquier información contenida en el Sitio es bajo su propio riesgo.',
            ],
          },
          {
            heading: '2. Sin Garantías',
            paragraphs: [
              'Paola Skin Lab no ofrece garantías con respecto a resultados específicos derivados del uso de nuestro contenido informativo, orientación o recursos de autocuidado. Los resultados pueden variar significativamente de persona a persona según factores individuales, tipos de piel y el cumplimiento del asesoramiento médico profesional.',
            ],
          },
          {
            heading: '3. Descargo de Responsabilidad de Enlaces Externos',
            paragraphs: [
              'El Sitio puede contener enlaces a otros sitios web o contenido que pertenezca o se origine en terceros. Dichos enlaces externos no son investigados, monitoreados o verificados por nosotros en cuanto a precisión, adecuación, validez, confiabilidad, disponibilidad o integridad.',
            ],
          },
          {
            heading: '4. Contáctenos',
            paragraphs: [
              'Si tiene alguna pregunta sobre este descargo de responsabilidad, por favor contáctenos en sales@paolaskinlab.com.',
            ],
          },
        ],
      },
      refund: {
        title: 'Política de Reembolso',
        intro:
          'Gracias por elegir Paola Skin Lab. Esta Política de Reembolso describe los términos que se aplican a cualquier producto, recurso digital, material educativo, consulta o servicio actual o futuro ofrecido por Paola Skin Lab.',
        sections: [
          {
            heading: '1. Compras en Línea',
            paragraphs: [
              'En este momento, nuestro sitio web no procesa compras ni pagos directos en línea. Paola Skin Lab es actualmente una plataforma informativa y educativa, y no se completan transacciones a través de este sitio web.',
            ],
          },
          {
            heading: '2. Productos y Servicios Futuros',
            paragraphs: [
              'Los productos digitales, recursos educativos, cursos en línea, consultas u otros servicios futuros que pueda ofrecer Paola Skin Lab podrán estar sujetos a términos de reembolso específicos comunicados al momento de la compra. Se recomienda a los clientes revisar dichos términos cuidadosamente antes de completar cualquier transacción.',
            ],
          },
          {
            heading: '3. Artículos No Reembolsables',
            paragraphs: [
              'Los siguientes elementos pueden considerarse no reembolsables:',
            ],
            list: [
              'Productos digitales a los que ya se haya accedido.',
              'Materiales que hayan sido descargados o entregados electrónicamente.',
              'Contenido o recursos educativos que hayan sido proporcionados en su totalidad.',
              'Consultas o servicios que ya hayan sido completados.',
            ],
          },
          {
            heading: '4. Cómo Solicitar un Reembolso',
            paragraphs: [
              'Todas las solicitudes de reembolso deben enviarse por escrito a sales@paolaskinlab.com. Por favor incluya su nombre completo, la dirección de correo electrónico utilizada para la compra, la fecha de compra y una explicación detallada del motivo de su solicitud.',
              'Las solicitudes de reembolso se revisan individualmente caso por caso. La aprobación queda a discreción exclusiva de Paola Skin Lab y depende de las circunstancias específicas de cada solicitud.',
            ],
          },
          {
            heading: '5. Contáctenos',
            paragraphs: [
              'Si tiene alguna pregunta sobre esta Política de Reembolso, por favor contáctenos en sales@paolaskinlab.com.',
            ],
          },
        ],
      },
    },
  },
}
